type ReadableStreamIteratorOptions = {
  preventCancel?: boolean;
};

async function* iterateReadableStream<T>(
  stream: ReadableStream<T>,
  preventCancel: boolean,
): AsyncGenerator<T, void, unknown> {
  const reader = stream.getReader();
  let completed = false;

  try {
    while (true) {
      const result = await reader.read();
      if (result.done) {
        completed = true;
        return;
      }
      yield result.value;
    }
  } finally {
    if (!completed && !preventCancel) {
      await reader.cancel().catch(() => undefined);
    }
    reader.releaseLock();
  }
}

function readableStreamValues<T>(
  this: ReadableStream<T>,
  options: ReadableStreamIteratorOptions = {},
): AsyncGenerator<T, void, unknown> {
  return iterateReadableStream(this, options.preventCancel === true);
}

export function installReadableStreamCompatibility(): void {
  if (typeof ReadableStream === "undefined") return;

  if (typeof Reflect.get(ReadableStream.prototype, "values") !== "function") {
    Object.defineProperty(ReadableStream.prototype, "values", {
      configurable: true,
      writable: true,
      value: readableStreamValues,
    });
  }

  if (
    typeof Reflect.get(ReadableStream.prototype, Symbol.asyncIterator) !==
    "function"
  ) {
    Object.defineProperty(ReadableStream.prototype, Symbol.asyncIterator, {
      configurable: true,
      writable: true,
      value: readableStreamValues,
    });
  }
}

installReadableStreamCompatibility();
